<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />

    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12>
        <v-card id="app_height" outlined tile>
          <v-layout pa-4 wrap justify-center>
            <v-flex text-center>
              <span style="font-size:16px;font-weight:600">Team Member Details</span>
            </v-flex>
          </v-layout>
          <v-layout px-5 wrap justify-center align="center">
            <v-flex>
              <v-card>
                <table class="logtable" style width="100%" v-if="query != null">
                  <tr>
                    <th>Photo</th>
                    <td>
                      <img
                        v-if="profilepic"
                        v-bind:src="baseURL+'/document/get/'+profilepic"
                        height="auto"
                        width="20%"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <td>{{query.name}}</td>
                  </tr>
                  <tr>
                    <th>Position</th>
                    <td>{{query.position}}</td>
                  </tr>

                  <tr>
                    <th>Qualification</th>
                    <td>{{query.qualification}}</td>
                  </tr>

                  <tr>
                    <th>Specialization</th>
                    <td>{{query.expertise}}</td>
                  </tr>

                  <tr>
                    <th>Experience</th>
                    <td>{{query.experience}}</td>
                  </tr>

                  <tr>
                    <th>Description</th>
                    <td v-html="query.description"></td>
                  </tr>
                </table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";

export default {
  props: ["id"],
  components: {
    VueElementLoading,
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      query: null,
      queryDate: null,
      profilepic: "",
    };
  },
  beforeMount() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/team/view/" + this.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data.status) {
            this.query = response.data.data;
            var data = response.data.data;
            this.id = response.data.data._id;
            var dt = new Date(this.query.create_date);
            dt = dt.toString();
            dt = dt.slice(4, 25);
            this.queryDate = dt;
            if (data.photo != undefined) {
              this.profilepic = data.photo;
            }
          } else {
            this.msg = response.data.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.showsnackbar = true;
        });
    },
  },
};
</script>
<style>
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
    min-width: 80vw;
  }
}
.logtable,
.logtable th,
.logtable td {
  border: 1px solid black;
  border-collapse: collapse;
}
.logtable .logtable th,
.logtable td {
  padding: 5px;
  padding-left: 20px;
  text-align: left;
}
.logtable th {
  text-align: left;
  padding: 5px;
  padding-left: 20px;

  max-width: 160px;
}
</style>